module.exports = __webpack_public_path__ + "media/images/article/2022_04_b-9c88d7186240fc43db69635e41bd0247.png";